export const shareTooltip =
  'Select “Share with your Organization” to allow subsidiaries of your parent organization to add this opportunity to their subsidiary, thus making it visible to their employees.';
